/* eslint-disable import/no-internal-modules */
import { useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { SignupSlide } from '@_widgets/auth';
import { PageTemplate } from '@_widgets/common';

import { authModel } from '@_entities/auth';
import { LeftChevronIcon } from '@_shared/icons';

import { slidePrev } from './Signup.logic';
import * as S from './SignupPage.style';

export function SignupPage() {
	const sliderRef = useRef<Slider>(null);

	const [idx, setIdx] = useState(0);
	const [submitData, setSubmitData] = useState<authModel.TSignupRequest>({
		nickname: '',
		optionalTerms: [],
		favorites: [],
		trafficSource: undefined,
	});

	// Signup Slide Settings
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,

		draggable: false,
		swipe: false,
		arrows: false,
		afterChange: (current: number) => {
			setIdx(current);
		},
	};

	return (
		<PageTemplate
			header={
				<S.Header>
					<S.BackIconWrapper
						onClick={() => {
							if (sliderRef.current) slidePrev(idx, sliderRef.current.slickPrev);
						}}
					>
						<LeftChevronIcon />
					</S.BackIconWrapper>
				</S.Header>
			}
			nav={false}
		>
			<S.SliderWrapper className="slider-container">
				<Slider {...settings} ref={sliderRef}>
					{/* Terms Page */}
					<SignupSlide.TermsSlide
						onNext={() => {
							sliderRef.current?.slickNext();
						}}
						setTerms={(terms: string[]) => {
							setSubmitData((prev) => ({
								...prev,
								optionalTerms: terms,
							}));
						}}
					/>

					<SignupSlide.NicknameSlide
						onNext={() => {
							sliderRef.current?.slickNext();
						}}
						setNickname={(nickname: string) => {
							setSubmitData((prev) => ({
								...prev,
								nickname,
							}));
						}}
					/>

					<SignupSlide.ReferralSlide
						onNext={() => {
							sliderRef.current?.slickNext();
						}}
						nickname={submitData.nickname}
						postReferral={(
							referral: authModel.TTrafficSource | '',
							details: string,
						) => {
							setSubmitData((prev) => {
								if (referral === '')
									return {
										...prev,
										trafficSource: undefined,
									};

								if (referral === 'TFCSRC06')
									return {
										...prev,
										trafficSource: {
											type: referral,
											details,
										},
									};

								return {
									...prev,
									trafficSource: {
										type: referral,
									},
								};
							});
						}}
					/>

					<SignupSlide.AgeNGenderSlide
						onNext={() => {
							sliderRef.current?.slickNext();
						}}
						nickname={submitData.nickname}
						setAgnNGender={(birthYear: number, gender: '남자' | '여자') => {
							setSubmitData((prev) => ({
								...prev,
								birthYear,
								gender,
							}));
						}}
					/>

					<SignupSlide.EmailSlide
						onNext={() => {
							sliderRef.current?.slickNext();
						}}
						nickname={submitData.nickname}
						setEmail={(email: string) => {
							setSubmitData((prev) => ({
								...prev,
								email,
							}));
						}}
					/>

					<SignupSlide.FavoritesSlide submitData={submitData} />
				</Slider>
			</S.SliderWrapper>
		</PageTemplate>
	);
}
